var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from 'moment';
import { Clock } from '@app/core/services/clock.service';
import * as i0 from "@angular/core";
import * as i1 from "./clock.service";
var DateService = /** @class */ (function () {
    function DateService(clock) {
        this.clock = clock;
    }
    DateService.prototype.getNextMonthDate = function (current) {
        var nextMonth = this
            .toMoment(current)
            .add(1, 'month')
            .toObject();
        return this.toSimpleDate(nextMonth);
    };
    DateService.prototype.getPreviousMonthDate = function (current) {
        var prevMonth = this
            .toMoment(current)
            .subtract(1, 'month')
            .toObject();
        return this.toSimpleDate(prevMonth);
    };
    DateService.prototype.stringToSimpleDate = function (date) {
        var momentObj = moment(date, [moment.HTML5_FMT.DATE, moment.HTML5_FMT.DATETIME_LOCAL_SECONDS]).toObject();
        return this.toSimpleDate(momentObj);
    };
    DateService.prototype.simpleDateToDate = function (date) {
        if (date.month) {
            date = __assign({}, date, { month: date.month - 1 });
        }
        return moment(date).toDate();
    };
    DateService.prototype.monthNameShort = function (month) {
        return moment({ month: month - 1 }).format('MMM');
    };
    DateService.prototype.toMoment = function (date) {
        if (date === undefined) {
            date = this.clock.now();
        }
        date = __assign({}, date, { month: date.month - 1 });
        return moment(date);
    };
    DateService.prototype.toSimpleDate = function (momentObj) {
        return {
            year: momentObj.years,
            month: momentObj.months + 1,
            day: momentObj.date,
            hour: momentObj.hours,
            minute: momentObj.minutes,
            second: momentObj.seconds,
            millisecond: momentObj.milliseconds
        };
    };
    DateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DateService_Factory() { return new DateService(i0.ɵɵinject(i1.Clock)); }, token: DateService, providedIn: "root" });
    return DateService;
}());
export { DateService };
